import { PaymentMethod } from '@stripe/stripe-js'
import { PaymentMethodsEntity } from 'libs/gb-front/auction/data-access/src/lib/+state/payment-methods.models'

export interface gbAttachPaymentMethod {
  payment_methods: PaymentMethod[]
  stripe_connect: string
  stripe_customer_id: string
  user: string
}

export interface stripeConnect {
  account_type: string
  charges_enabled: boolean
  display_name: string
  platform_account_id: string
  platform_publishable_key: string
  stripe_publishable_key: string
  stripe_user_id: string
  uuid: string
}

export interface paymentRequestOptions {
  country: string
  currency: string
  total: {
    label: string
    amount?: number
  }
  requestPayerName: boolean
  requestPayerEmail: boolean
}

export interface canMakePaymentResult {
  applePay: boolean
  googlePay: boolean
}

export interface AttachPaymentMethodReturn {
  payment_methods: PaymentMethodsEntity[]
  stripe_connect: string
  stripe_customer_id: string
  user: string
}
export interface DetachPaymentMethodReturn {
  payment_methods: PaymentMethodsEntity[]
  stripe_connect: string
  stripe_customer_id: string
  user: string
}

export enum StripeAccountTypeEnum {
  Standard = 'standard',
  Express = 'express',
}
